import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from "@environments/environment";

@Component({
  selector: 'reports-menu',
  templateUrl: './reports-menu.component.html',
  styleUrls: ['./reports-menu.component.scss']
})
export class ReportsMenuComponent implements OnInit {

  menu = environment.ADMINNAVBAR.REPORTS;

  constructor(public router: Router) {
  }

  ngOnInit() {
  }

}
